import { h, ComponentType } from "preact";
import { forwardRef } from "preact/compat";

function withTransformedProps<P, T>(
    WrappedComponent: ComponentType<T>,
    transformProps: (props: P) => T
): ComponentType<P> {
    return forwardRef((props: P, ref) => {
        const transformedProps = transformProps(props);
        return <WrappedComponent ref={ref} {...transformedProps}/>;
    });
}

export default withTransformedProps;

